<template>
	<div>
		<a-drawer title="审批记录" placement="right" :visible="visibleApproval" @close="onClose" :destroyOnClose="true" width="85%">
			<div class="approvalBtn">
				<a-button style="float: left;" v-if="keyy == 'officeDocKey'" @click="printOfficeDocPage()">导出</a-button>
				<a-button style="float: left;" v-if="keyy == 'approvalKey'" @click="printPage()">打印</a-button>
				<a-button type="primary" v-for="(i,index) in pvmList" :key="i" @click="submitTo(i)">{{i}}</a-button>
			</div>
			<!-- 打印信息 -->
			<div v-show="false">
				<!-- 报销 -->
				<div id="printMe" >
					<div style="text-align: center;font-weight: 800;margin: 15px auto;">报销信息</div>
					<p><b>报销人所在部门:</b> {{ opprove.deptName?opprove.deptName:"- -" }}</p><br/>
					<p><b>公司主体:</b><span style="display: inline-block;width: 251px;">{{ opprove.companyType_text?opprove.companyType_text:" - - " }}</span><b>提交人:</b>{{opprove.realname}}</p><br/>
					<p><b>报销类别:</b><span style="display: inline-block;width: 251px;">{{ opprove.approvalType_text?opprove.approvalType_text:" - - " }}</span><b>报销人:</b>{{opprove.realUserName}}</p><br/>
					<a-table :columns="business" :dataSource="businessData" bordered :pagination="false">
						<template slot="format3" slot-scope="text,scope">
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.startTime||'--'}}</div>
							<div v-if="currentVal == 4" v-for="i in scope.detail" class="borderLine">{{i.payeeName||'--'}}</div>
							<div v-if="currentVal == 5" v-for="i in scope.detail" class="borderLine">{{i.borrowerName||'--'}}</div>
						</template>
						<template slot="format4" slot-scope="text,scope">
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.startPlace||'--'}}</div>
							<div v-if="currentVal == 4" v-for="i in scope.detail" class="borderLine">{{i.bankAccount||'--'}}</div>
							<div v-if="currentVal == 5" v-for="i in scope.detail" class="borderLine">{{i.repaymentTime||'--'}}</div>
						</template>
						<template slot="format5" slot-scope="text,scope">
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.endTime||'--'}}</div>
							<div v-if="currentVal == 4" v-for="i in scope.detail" class="borderLine">{{i.bankName||'--'}}</div>
						</template>
						<template slot="format9" slot-scope="text,scope">
							<div v-for="i in scope.detail" class="borderLine">{{i.endPlace||'--'}}</div>
						</template>
						<template slot="format1" slot-scope="text,scope">
							<div v-for="i in scope.detail" class="borderLine">{{i.use||'--'}}</div>
						</template>
						<template slot="format8" slot-scope="text,scope">	<!-- 编号 -->
							<div v-for="i in scope.detail" class="borderLine">{{i.number||'--'}}</div>
						</template>
						<template slot="format6" slot-scope="text,scope">  <!-- 发票类型 -->
							<div v-for="i in scope.detail" class="borderLine">{{i.invoiceCategory||'--'}}</div>
						</template>
						<template slot="format7" slot-scope="text,scope">	<!-- 金额 -->
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.subtotal||'--'}}</div>
							<div v-if="currentVal != 2" v-for="i in scope.detail" class="borderLine">{{i.money||'--'}}</div>
						</template>
						<template slot="format10" slot-scope="text,scope">   <!-- 状态 -->
							<div v-for="i in scope.detail" class="borderLine">{{i.state == '1'?"已确认":"未确认"}}</div>
						</template>
					</a-table>
					<div style="text-align: center;font-weight: 800;margin: 15px auto;">审批记录</div>
					<a-table :columns="historys" :dataSource="historyData" bordered :pagination="false">
						<template slot="formatSign" slot-scope="text">
							<img v-if="text" :src="text" width="50" height="50">
						</template>
					</a-table>
				</div>
				<!-- 公文 -->
				<div id="printOfficeDoc">
					<h2 style="text-align: center;font-weight: 800;margin: 15px auto;">{{opprove.title}}</h2>
					<div style="padding:10px;margin: 10px 0;" v-html="opprove.content"></div>
					<div style="text-align: center;font-weight: 800;margin: 15px auto;">审批记录</div>
					<a-table :columns="historys" :dataSource="historyData" bordered :pagination="false">
						<template slot="formatSign" slot-scope="text">
							<img v-if="text" :src="text" width="50" height="50">
						</template>
					</a-table>
				</div>
			</div>
			<div>
			<a-collapse v-model="defaultkey" :bordered="false" :forceRender="true">
				<!-- 知识理论库审批 -->
				<a-collapse-panel v-if="keyy.indexOf('knowledgeTheoryKey') > -1 || keyy.indexOf('knowledgeTheoryKeyOther') > -1" header="知识理论库申请" key="1" :style="customStyle">
					  <p><b>文件全称:</b> {{ '['+opprove.deptName + '-'+ opprove.category +']'+opprove.filename + (opprove.versionDate + "").slice(0,10)}}</p><br/>
					  <p><b>文件名:</b> {{ opprove.filename?opprove.filename:" - - " }}</p><br/>
					  <p><b>文件编号:</b> {{ opprove.sn?opprove.sn:" - - " }}</p><br/>
					  <p><b>类目:</b> {{ opprove.category?opprove.category:" - - " }}</p><br/>
					  <p><b>文件性质:</b> {{ opprove.nature?opprove.nature:" - - " }}</p><br/>
					  <p><b>文件版本日期:</b> {{ opprove.versionDate?(opprove.versionDate + "").slice(0,10):" - - " }}</p><br/>
					  <p><b>上传人:</b> {{ opprove.createName?opprove.createName:" - - "}}</p><br/>
					   <p><b>上传时间:</b> {{ opprove.createTime?(opprove.createTime+"").slice(0,10):" - - "}}</p><br/>
					   <p>附件 :
					  <div v-if="opproveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in opproveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
					  </div>
					  </p><br/>
				</a-collapse-panel>
				<!-- 申请回款审批 -->
				<a-collapse-panel v-if="keyy.indexOf('remainingKey') > -1 " header="回款申请" key="1" :style="customStyle">
					  <p><b>客户名称:</b> {{ opprove.customerName?opprove.customerName:" - - " }}</p><br/>
					  <p><b>打款公司:</b> {{ opprove.companyName?opprove.companyName:" - - " }}</p><br/>
					  <p><b>回款金额:</b> {{ opprove.money?opprove.money:" - - " }}</p><br/>
					  <p><b>申请人:</b> {{ opprove.createName?opprove.createName:" - - " }}</p><br/>
					  <p><b>打款账户:</b> {{ opprove.collectionAccount?opprove.collectionAccount:" - - " }}</p><br/>
					  <p><b>打款时间:</b> {{ opprove.paymentTime?(opprove.paymentTime+"").slice(0,10):" - - "}}</p><br/>
					  <p><b>回款账户:</b> {{ opprove.bankAccountName?opprove.bankAccountName:" - - " }}</p><br/>
					  <p><b>广告服务费:</b> {{ opprove.billType == '1' ? '是':'否' }}</p>
					  <p><b>备注:</b> {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
				</a-collapse-panel>
				<!-- 补充协议审批 -->
				<a-collapse-panel v-if="keyy.indexOf('sideKey') > -1 " header="补充协议详情" key="1" :style="customStyle">
					  <p>合同主体 : {{ opprove.subject_text?opprove.subject_text:" - - " }}</p><br/>
					  <p>合同编号 : {{ opprove.agreementNum?opprove.agreementNum:" - - " }}</p><br/>
					  <p>合同名称: {{ opprove.agreementName?opprove.agreementName:" - - " }}</p><br/>
					  <p>补充协议名称: {{ opprove.sideName?opprove.sideName:" - - " }}</p><br/>
					  <p>合同折扣 : {{ opprove.rebate_text?opprove.rebate_text:" - - " }}</p><br/>
						<div v-if="opprove.sideType == '2'">
							<p>折扣条款 : {{ opprove.rebateClause?opprove.rebateClause:" - - " }}</p><br/>
							<p>账期 : {{ opprove.yearRefund?opprove.yearRefund:" - - " }}</p><br/>
						</div>
					  <p>税率 : {{ opprove.taxRate?opprove.taxRate:" - - " }}</p><br/>
					  <p>对接人 : {{ opprove.dockingPerson?opprove.dockingPerson:" - - " }}</p><br/>
					  <p>公司收款账号 : {{ opprove.collectionAccount_text?opprove.collectionAccount_text:" - - " }}</p><br/>
					  <p>签订时间 : {{ opprove.agreementTime?(opprove.agreementTime+"").slice(0,10):" - - " }}</p><br/>
					  <!-- <p>合同内容要点 : {{ opprove.agreementRemark?opprove.agreementRemark:" - - " }}</p> --><br/>
						<div v-if="opprove.sideType == '1'">
							<p>合同金额: {{ opprove.sideMoney?opprove.sideMoney:" - - " }}</p><br/>
							<p>付款时间 : {{ opprove.payTimeType_text?opprove.payTimeType_text:" - - " }}</p><br/>
							<p>KOl及合作方式: {{ opprove.cooperationType?opprove.cooperationType:" - - " }}</p><br/>
							<p>项目执行日期 : {{ opprove.projectTime?(opprove.projectTime+"").slice(0,10):" - - " }}</p><br/>
							<p>实际执行情况 : {{ opprove.reality_text?opprove.reality_text:" - - " }}</p><br/>
						</div>
					  <p>创建时间: {{ opprove.createTime?(opprove.createTime+"").slice(0,10):" - - "}}</p><br/>
					  <p>补充协议备注 : {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
					  <p>附件 :
					  <div v-if="opproveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in opproveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
					  </div>
					  </p><br/>
				</a-collapse-panel>
				<a-collapse-panel v-if="keyy.indexOf('sideKey') > -1 && opprove.sideType == '1'" header="回款计划" key="5" :style="customStyle">
					<div class="contractRi">
						<a-timeline>
							<a-timeline-item v-for="(item,index) in opprove.refundJson" :key="index">
								<div class="head">
									<div class="headLf">
										<h3>第{{index + 1}}期</h3>
									</div>
								</div>
								<p>
									<span class="lfColor">预计回款日期</span>
									<span class="riColor">{{item.refundTime?item.refundTime.slice(0,10):""}}</span>
								</p>
								<p>
									<span class="lfColor">预计回款金额</span>
									<span class="riColor">¥ {{item.money}}</span>
								</p>
								<p>
									<span class="lfColor">已回款金额</span>
									<span class="riColor"> ¥ {{item.refundMoney}}</span>
								</p>
							</a-timeline-item>
						</a-timeline>
					</div>
				</a-collapse-panel>
				<!-- 对账单审批 -->
				<a-collapse-panel v-if="keyy.indexOf('billKey') > -1 " header="对账单详情" key="1" :style="customStyle">
					  <p>合同名称 : {{ opprove.agreementName?opprove.agreementName:" - - " }}</p><br/>
					  <p>对账单名称 : {{ opprove.billName?opprove.billName:" - - " }}</p><br/>
					  <p>创建人 : {{ opprove.realname?opprove.realname:" - - " }}</p><br/>
					  <p>创建时间 : {{ opprove.createTime?(opprove.createTime+"").slice(0,10):" - - " }}</p><br/>
					  <p>附件 :
					  <div v-if="opproveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in opproveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
					  </div>
					  </p><br/>
					  <p>
					  	<span class="lfColor"><b>账号订单:</b></span>
					  </p>
					  <a-table :columns="columnsOrder" :data-source="accountOrderList" :pagination="false" >
					  </a-table>
				</a-collapse-panel>

				<!-- 供应商合同审批 -->
				<a-collapse-panel v-if="keyy.indexOf('supplierAgreement') > -1 " header="供应商合同详情" key="1" :style="customStyle">
					  <p>合同编号 : {{ opprove.agreementNum?opprove.agreementNum:" - - " }}</p><br/>
					  <p>合同名称 : {{ opprove.agreementName?opprove.agreementName:" - - " }}</p><br/>
					  <p>合同金额 : {{ opprove.money?opprove.money:" - - " }}</p><br/>
					  <p>合同丙方 : {{ opprove.customer?opprove.customer:" - - " }}</p><br/>
					  <p>接单人 : {{ opprove.realname?opprove.realname:" - - " }}</p><br/>
					  <p>签订时间 : {{ opprove.agreementTime?(opprove.agreementTime+"").slice(0,10):" - - " }}</p><br/>
					  <p>备注 : {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
					  <p>附件 :
					  <div v-if="opproveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in opproveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
					  </div>
					  </p><br/>
				</a-collapse-panel>

				<!-- 年框合同审批 -->
				<a-collapse-panel v-if="keyy.indexOf('yearAgreement') > -1 " header="年框合同详情" key="1" :style="customStyle">
					  <p>合同主体 : {{ opprove.subject_text?opprove.subject_text:" - - " }}</p><br/>
					  <p>合同编号 : {{ opprove.agreementNum?opprove.agreementNum:" - - " }}</p><br/>
					  <p>合同名称 : {{ opprove.agreementName?opprove.agreementName:" - - " }}</p><br/>
					  <p>合同折扣 : {{ opprove.rebate_text?opprove.rebate_text:" - - " }}</p><br/>
					  <p>折扣条款 : {{ opprove.rebateClause?opprove.rebateClause:" - - " }}</p><br/>
					  <p>税率 : {{ opprove.taxRate?opprove.taxRate:" - - " }}</p><br/>
					  <p>账期 : {{ opprove.yearRefund?opprove.yearRefund:" - - " }}</p><br/>
					  <p>合同内容要点 : {{ opprove.agreementRemark?opprove.agreementRemark:" - - " }}</p><br/>
					  <p>合同甲方 : {{ opprove.customerName?opprove.customerName:" - - " }}</p><br/>
					  <p>甲方对接人 : {{ opprove.dockingPerson?opprove.dockingPerson:" - - " }}</p><br/>
					  <p>公司收款账号 : {{ opprove.collectionAccount_text?opprove.collectionAccount_text:" - - " }}</p><br/>
					  <p>签订时间 : {{ opprove.agreementTime?(opprove.agreementTime+"").slice(0,10):" - - " }}</p><br/>
					  <p>备注 : {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
					  <p>附件 :
					  <div v-if="opproveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in opproveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
					  </div>
					  </p><br/>
				</a-collapse-panel>


				<!-- 单项合同审批 -->
				<a-collapse-panel v-if="keyy.indexOf('singleAgreement') > -1 " header="单项合同详情" key="1" :style="customStyle">
					  <p>合同主体 : {{ opprove.subject_text?opprove.subject_text:" - - " }}</p><br/>
					  <p>广告服务类发票 : {{opprove.invoiceFlag=='1'?'是':(opprove.invoiceFlag=='2'?'否':'无发票')}}</p><br/>
					  <p>合同编号 : {{ opprove.agreementNum?opprove.agreementNum:" - - " }}</p><br/>
					  <p>合同名称 : {{ opprove.agreementName?opprove.agreementName:" - - " }}</p><br/>
					  <p>合同金额 : {{ opprove.money?opprove.money:" - - " }}</p><br/>
					  <p>合同甲方 : {{ opprove.customerName?opprove.customerName:" - - " }}</p><br/>
					  <p>甲方对接人 : {{ opprove.dockingPerson?opprove.dockingPerson:" - - " }}</p><br/>
					  <p>KOl及合作方式 : {{ opprove.cooperationType?opprove.cooperationType:" - - " }}</p><br/>
					  <p>公司收款账号 : {{ opprove.collectionAccount_text?opprove.collectionAccount_text:" - - " }}</p><br/>
					  <p>支付方式 : {{ opprove.payType_text?opprove.payType_text:" - - " }}</p><br/>
					  <p>支付方式备注 : {{ opprove.payRemark?opprove.payRemark:" - - " }}</p><br/>
					  <p>税率 : {{ opprove.taxRate?opprove.taxRate:" - - " }}</p><br/>
					  <p>合同折扣 : {{ opprove.rebate_text?opprove.rebate_text:" - - " }}</p><br/>
					  <p>付款时间 : {{ opprove.payTimeType_text?opprove.payTimeType_text:" - - " }}</p><br/>
					  <p>付款时间备注 : {{ opprove.payTimeRemark?opprove.payTimeRemark:" - - " }}</p><br/>
					  <p>签订时间 : {{ opprove.agreementTime?(opprove.agreementTime+"").slice(0,10):" - - " }}</p><br/>
					  <p>项目执行日期 : {{ opprove.projectTime?(opprove.projectTime+"").slice(0,10):" - - " }}</p><br/>
					  <p>实际执行情况 : {{ opprove.reality_text?opprove.reality_text:" - - " }}</p><br/>
					  <p>合同内容要点 : {{ opprove.agreementRemark?opprove.agreementRemark:" - - " }}</p><br/>
					  <p>备注 : {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
					  <p>附件 :
						  <div v-if="opproveFile.length < 1" >
							<b>暂无附件</b>
						  </div>
						  <div v-for="(item,index) in opproveFile" :key="index">
							<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
						  </div>
					  </p><br/>
				</a-collapse-panel>
				<!-- 回款计划 -->
				<a-collapse-panel v-if="keyy.indexOf('singleAgreement') > -1 " header="回款计划" key="4" :style="customStyle">
					<div class="contractRi">
						<a-timeline>
							<a-timeline-item v-for="(item,index) in planData" :key="index">
								<div class="head">
									<div class="headLf">
										<h3>第{{index + 1}}期</h3>
									</div>
								</div>
								<p>
									<span class="lfColor">预计回款日期</span>
									<span class="riColor">{{item.refundTime?item.refundTime.slice(0,10):""}}</span>
								</p>
								<p>
									<span class="lfColor">预计回款金额</span>
									<span class="riColor">¥ {{item.money}}</span>
								</p>
								<p>
									<span class="lfColor">已回款金额</span>
									<span class="riColor"> ¥ {{item.refundMoney}}</span>
								</p>
							</a-timeline-item>
						</a-timeline>
					</div>
				</a-collapse-panel>
				<!-- 客户审批 -->
				<a-collapse-panel v-if="keyy.indexOf('customerKey') > -1 || keyy.indexOf('businessCustomerKey') > -1 " header="客户详情" key="1" :style="customStyle">
					  <p>客户名称: {{ opprove.name?opprove.name:" - - " }}</p><br/>
					  <p>基础折扣: {{ opprove.discount?opprove.discount:" - - " }}</p><br/>
					  <p>返点比例: {{ opprove.rebateRatio?opprove.rebateRatio + "%":" - - " }}</p><br/>
					  <p>返点方式: {{ opprove.rebateWay_text?opprove.rebateWay_text:" - - " }}</p><br/>
					  <p>平台折扣 :
					  						  <div v-if="!opprove.platformDiscount || opprove.platformDiscount.length < 1 " >
					  							<b>暂无平台折扣</b>
					  						  </div>
					  						  <div v-for="(item,index) in opprove.platformDiscount" :key="index">
					  							&nbsp;&nbsp;&nbsp;&nbsp;{{item}}
					  						  </div>
					  </p><br/>
					  <p>单位名称: {{ opprove.unitName?opprove.unitName:" - - " }}</p><br/>
					  <p>单位税号: {{ opprove.taxNumber?opprove.taxNumber:" - - " }}</p><br/>
					  <p>开户银行: {{ opprove.bank?opprove.bank:" - - " }}</p><br/>
					  <p>银行账号: {{ opprove.bankAccount?opprove.bankAccount:" - - " }}</p><br/>
					  <p>注册地址: {{ opprove.registeredAddress?opprove.registeredAddress:" - - " }}</p><br/>
					  <p>注册电话: {{ opprove.phone?opprove.phone:" - - " }}</p><br/>
					  <p>账期(月): {{ opprove.acctPeriod?opprove.acctPeriod:" - - " }}</p><br/>
					  <p>已合作次数: {{ opprove.numberCooperation ?opprove.numberCooperation:" - - "}}</p><br/>
					  <p>备注 : {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
				</a-collapse-panel>

				<!-- 发票审批 -->
				<a-collapse-panel v-if=" keyy.indexOf('invoiceKey') > -1 " header="发票申请" key="1" :style="customStyle">
					  <p>开票主体: {{ opprove.billingSubjectStr?opprove.billingSubjectStr:" - - " }}</p><br/>
					  <p>客户: {{ opprove.customerName }}</p><br/>
					  <p>发票类型 : {{ opprove.invoiceTypeStr }}</p><br/>
					  <p>抬头类型 : {{ opprove.invoiceTitle == 1 ? '个人': '企业' }}</p><br/>
					  <p>发票抬头 : {{ opprove.invoiceTitleText }}</p><br/>
					  <p>票属月份 : {{ opprove.invoiceMonth }}</p><br/>
					  <template v-if="opprove.invoiceTitle != 1">
						  <p>单位名称 : {{ opprove.unitName }}</p><br/>
						  <p>单位税号 : {{ opprove.taxNumber }}</p><br/>
						  <p>开户银行 : {{ opprove.bank }}</p><br/>
						  <p>银行账号 : {{ opprove.bankAccount }}</p><br/>
						  <p>注册地址 : {{ opprove.registeredAddress }}</p><br/>
						  <p>注册电话 : {{ opprove.phone }}</p><br/>
					  </template>
					  <p>发票内容 : {{ opprove.invoiceContent }}</p><br/>
					  <p>备注 : {{ opprove.remark?opprove.remark:" - - " }}</p><br/>
					  <p>开票总额 : {{ opprove.total }}  &nbsp;&nbsp;<span v-if="opprove.total != opprove.priceTotal && opprove.whetherSelectCustomer == '1'"  style="color:red;font-size:16px;font-weight:bold;">    (开票金额与订单金额总和不一致)</span></p>  <br/>
					  <p>是否电子票 : {{ opprove.whetherElectronicTicketStr }}</p><br/>
					  <p>申请附件 :
					  <div v-if="opproveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in opproveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
						<a-divider v-if="fileTypeArr.includes(item.fileSurffix.toLowerCase())" type="vertical" />
						<a size="small" v-if="fileTypeArr.includes(item.fileSurffix.toLowerCase())" @click="getPhotoStream(item)">预览图片</a>
					  </div>
					  </p>
					  <p>审批附件 :
					  <div v-if="approveFile.length < 1" >
					  	<b>暂无附件</b>
					  </div>
					  <div v-for="(item,index) in approveFile" :key="index">
					  	<a href="javascript:;" @click="downImg(item)">{{item.fileFullName}}</a>
					  						<a-divider v-if="fileTypeArr.includes(item.fileSurffix.toLowerCase())" type="vertical" />
					  						<a size="small" v-if="fileTypeArr.includes(item.fileSurffix.toLowerCase())" @click="getPhotoStream(item)">预览图片</a>
					  </div>
					  </p>
					  <br/>
					  <p><a-button type="primary" @click="invoiceDetail">查看明细</a-button></p><br>
				</a-collapse-panel>


				<!-- 借用管理 -->
				<a-collapse-panel v-if=" keyy.indexOf('articleBorrowingKey') > -1  " header="借用管理" key="1" :style="customStyle">
					  <p>借记人姓名: {{ opprove.borrowName }}</p><br/>
					  <!-- <p>公司信息: {{ opprove.company }}</p><br/> -->
					  <p>借用资产: {{ opprove.equipment }}</p><br/>
					  <p>借用数量: {{ opprove.borrowNum }}</p><br/>
					  <p>借用理由: {{ opprove.cause }}</p><br/>
					  <p>申请借用时间: {{ opprove.createTime }}</p><br/>
					  <p>预计归还时间: {{ opprove.returnTime }}</p><br/>
					  <p>实际归还时间: {{ opprove.practicalReturnTime }}</p><br/>
					  <p>备注: {{ opprove.remark }}</p><br/>
				</a-collapse-panel>
				<!-- 公文业务详情 -->
				<a-collapse-panel v-if="keyy.indexOf('officeDocKey') > -1   " header="公文详情" key="1" :style="customStyle">
					<div>
						<h2 style="text-align: center;">{{opprove.title?opprove.title:" - - "}}</h2>
						<div style="display: flex;justify-content: space-around;"><span>发送人：{{opprove.uName?opprove.uName:" - - "}}</span> <span>发送时间：{{opprove.createTime}}</span></div>
						<div style="margin: 10px 0;">公文类别：{{opprove.typeName?opprove.typeName:" - - "}}</div>
						<div style="margin: 10px 0;">是否置顶：{{opprove.setting == 1 ? '置顶':'未置顶'}}</div>
						<div style="margin: 10px 0;">发送范围：{{opprove.sendRange?opprove.sendRange:" - - "}}</div>
						<div style="padding:10px;margin: 10px 0;" v-html="opprove.content"></div>
					</div>
					<!-- <a-form-item label="附件" v-bind="formItemLayout">
							<UploadFile :params="fileParams" :defaultFileList="fileArr" :isDisplay="false"></UploadFile>
							<div v-if="fileArr.length==0">无</div>
							<a-button v-if="fileArr.length!=0" type="primary" @click="downloadEmployeeZip">全部导出</a-button>
						</a-form-item> -->
				</a-collapse-panel>
				<!--  报销业务详情 -->
				<a-collapse-panel v-if="keyy.indexOf('approvalKey') > -1  " header="业务详情" key="1" :style="customStyle">
					<p><b>报销人所在部门:</b> {{ opprove.deptName?opprove.deptName:"- -" }}</p><br/>
					<p><b>公司主体:</b><span style="display: inline-block;width: 251px;">{{ opprove.companyType_text?opprove.companyType_text:" - - " }}</span><b>提交人:</b>{{opprove.realname}}</p><br/>
					<p><b>报销类别:</b><span style="display: inline-block;width: 251px;">{{ opprove.approvalType_text?opprove.approvalType_text:" - - " }}</span><b>报销人:</b>{{opprove.realUserName}}</p><br/>
					<a-table :columns="business" :dataSource="businessData" bordered :pagination="false">
						<template slot="format3" slot-scope="text,scope">
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.startTime||'--'}}</div>
							<div v-if="currentVal == 4" v-for="i in scope.detail" class="borderLine">{{i.payeeName||'--'}}</div>
							<div v-if="currentVal == 5" v-for="i in scope.detail" class="borderLine">{{i.borrowerName||'--'}}</div>
						</template>
						<template slot="format4" slot-scope="text,scope">
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.startPlace||'--'}}</div>
							<div v-if="currentVal == 4" v-for="i in scope.detail" class="borderLine">{{i.bankAccount||'--'}}</div>
							<div v-if="currentVal == 5" v-for="i in scope.detail" class="borderLine">{{i.repaymentTime||'--'}}</div>
						</template>
						<template slot="format5" slot-scope="text,scope">
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.endTime||'--'}}</div>
							<div v-if="currentVal == 4" v-for="i in scope.detail" class="borderLine">{{i.bankName||'--'}}</div>
						</template>
						<template slot="format9" slot-scope="text,scope">
							<div v-for="i in scope.detail" class="borderLine">{{i.endPlace||'--'}}</div>
						</template>
						<template slot="format1" slot-scope="text,scope">
							<div v-for="i in scope.detail" class="borderLine">{{i.use||'--'}}</div>
						</template>
						<template slot="format8" slot-scope="text,scope">	<!-- 编号 -->
							<div v-for="i in scope.detail" class="borderLine">{{i.number||'--'}}</div>
						</template>
						<template slot="format6" slot-scope="text,scope">  <!-- 发票类型 -->
							<div v-for="i in scope.detail" class="borderLine">{{i.invoiceCategory||'--'}}</div>
						</template>
						<template slot="format7" slot-scope="text,scope">	<!-- 金额 -->
							<div v-if="currentVal == 2" v-for="i in scope.detail" class="borderLine">{{i.subtotal||'--'}}</div>
							<div v-if="currentVal != 2" v-for="v in scope.detail" class="borderLine">{{v.money||'--'}}</div>
						</template>
						<template slot="format10" slot-scope="text,scope">   <!-- 状态 -->
							<div v-for="i in scope.detail" class="borderLine">{{i.state == '1'?"已确认":"未确认"}}</div>
						</template>
						<template slot="format11" slot-scope="text,scope"><!-- 凭证 -->
							<a href="javascript:;" @click="lookImg(scope)">查看</a>
						</template>
					</a-table>

					</a-collapse-panel>
					<a-collapse-panel v-if="keyy.indexOf('customerKey') > -1 || keyy.indexOf('businessCustomerKey') > -1  " header="客户变更记录" key="4" :style="customStyle">
						<a-table :columns="customerHistorys" :dataSource="customerHistoryData" :pagination="false" >
							<template slot="formatOperate" slot-scope="text,scope">
								<div v-for="item in scope.operateDataList ">
									<div v-if="item.platformType &&item.change =='delete' ">
										删除平台:
										<font color="red">{{ item.platformType }}</font>
									</div>
									<div v-if="item.platformType && item.eleDiscount ">
										{{item.change == 'add' ?'新增':(item.change == 'update'?'变更':'删除')}}平台:
										<font color="red">{{ item.platformType }}</font>
										<span v-if="item.change == 'update'">
											变更元素:
											<font color="red">{{ item.eleDiscount }}</font>
											, 变更前:
											<font color="red">{{ item.beforeDiscount }}</font>
											, 变更后:
											<font color="red">{{ item.afterDiscount }}</font>
										</span>
										<span v-if="item.change == 'add'">
											新增元素:
											<font color="red">{{ item.eleDiscount }}</font>
											, 值:
											<font color="red">{{ item.afterDiscount }}</font>
										</span>
									</div>
									<div v-if="item.platformType && item.eleRebateWay">
										{{item.change == 'add' ?'新增':(item.change == 'update'?'变更':'删除')}}平台:
										<font color="red">{{ item.platformType }}</font>
										<span v-if="item.change == 'update'">
											变更元素:
											<font color="red">{{ item.eleRebateWay }}</font>
											, 变更前:
											<font color="red">{{ item.beforeRebateWay }}</font>
											, 变更后:
											<font color="red">{{ item.afterRebateWay }}</font>
										</span>
										<span v-if="item.change == 'add'">
											新增元素:
											<font color="red">{{ item.eleRebateWay }}</font>
											, 值:
											<font color="red">{{ item.afterRebateWay }}</font>
										</span>
									</div>
									<div v-if="item.platformType && item.eleRebateRatio">
										{{item.change == 'add' ?'新增':(item.change == 'update'?'变更':'删除')}}平台:
										<font color="red">{{ item.platformType }}</font>
										<span v-if="item.change == 'update'">
											变更元素:
											<font color="red">{{ item.eleRebateRatio }}</font>
											, 变更前:
											<font color="red">{{ item.beforeRebateRatio }}</font>
											, 变更后:
											<font color="red">{{ item.afterRebateRatio }}</font>
										</span>
										<span v-if="item.change == 'add'">
											新增元素:
											<font color="red">{{ item.eleRebateRatio }}</font>
											, 值:
											<font color="red">{{ item.afterRebateRatio }}</font>
										</span>
									</div>

									<span v-if="scope.operateType == 'UPDATE' && item.ele ">
										变更元素:
										<font color="red">{{ item.ele }}</font>
										, 变更前:
										<font color="red">{{ item.before }}</font>
										, 变更后:
										<font color="red">{{ item.after }}</font>
									</span>
									<span v-if="scope.operateType == 'ADD' && item.ele ">
										新增元素:
										<font color="red">{{ item.ele }}</font>
										, 值:
										<font color="red">{{ item.after }}</font>
									</span>
								</div>

							</template>
						</a-table>
					</a-collapse-panel>
					<a-collapse-panel header="审批记录" key="2" :style="customStyle">
						<a-table :columns="keyy.indexOf('invoiceKey') > -1 ? historys1:historys" :dataSource="historyData" :pagination="false" ref="history">
							<template slot="formatSign" slot-scope="text">
								<img v-if="text" :src="text" width="50" height="50">
							</template>
						</a-table>
					</a-collapse-panel>

					<a-collapse-panel header="流程图" key="3" :style="customStyle">
						<div style="overflow-x: auto;">
							<img :src="iframeUrl" />
						</div>
					</a-collapse-panel>
				</a-collapse>
			</div>
		</a-drawer>
		<!--审批批注-->
		<a-modal :title="outcome" v-model="visibleAdopt" @ok="adoptOk" @cancel="cancel" :destroyOnClose="true" width="40%">
			<!-- 是否电子票 -->
			<!-- <a-form-item v-if="outcome == '通过' && keyy == 'invoiceKey' && data.name == '发票-财务审批'" label="是否电子票" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-select showSearch style="width:100%" placeholder="请选择是否电子票" v-model="whetherElectronicTicket" :allowClear="true" :filterOption="false">
					<a-select-option v-for="item in whetherArr" :key="item.key">{{item.value}}</a-select-option>
				</a-select>
			</a-form-item> -->
			<!-- 发票代码 -->
			<a-form-item v-if="outcome == '通过' && keyy == 'invoiceKey' && data.name == '发票-财务审批'" label="发票号码" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-input v-model="invoiceNum" :rows="4" />
			</a-form-item>
			<a-form-item v-if="outcome == '通过' && keyy == 'invoiceKey' && data.name == '发票-财务审批'" label="发票张数" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-input-number v-model="invoiceNumber"  :min="0"  :step="1" />
			</a-form-item>
			<!-- 注意事项(功能暂未完善) -->
			<!-- <a-form-item v-if="outcome == '通过' && termArray && termArray.length > 0 " label="注意事项" :label-col="{ span: 3 }" :wrapper-col="{ span: 21}">
				<div class="term" v-for="(item,index) in termArray" :key="index">
					<div class="term-lf" style="color: red;" v-if="item.keyy == 1 ">
						{{item.text}}
					</div>
					<div class="term-lf" v-if="item.keyy != 1 ">
						{{item.text}}
					</div>
					<div class="term-ri">
						<a-button type="primary" :disabled="item.state == 1" @click="termBtn(item)">{{item.state == 1?"已确认":" 确 认 "}}</a-button>
					</div>
				</div>
			</a-form-item> -->
			<a-form-item label="批注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-textarea v-model="message" :rows="4" />
			</a-form-item>
			<a-form-item v-if="outcome == '通过' && keyy == 'invoiceKey' && data.name == '发票-财务审批'" label="审批附件" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<UploadFile :params="fileParams" :defaultFileList="fileArr"></UploadFile>
			</a-form-item>
			<a-form-item label="下一步节点" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				 {{lastNodeName}}
			</a-form-item>
			<a-form-item label="下一步审批人" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				{{nextUserNames}}
			</a-form-item>
			<a-form-item v-if="lastNode.chooseUser == 1  " label="审批人" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-select
					mode="multiple"
					style="width: 100%"
					@change="selectPerson"
					placeholder="请选择审批人"
				  >
					 <a-select-option v-for="item in userArr" :value="item.userId" :key="item.userId" >{{item.realname}}</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item v-if="outcome == '通过' && keyy == 'invoiceKey' && ((data.name == '发票-财务审批' && opprove.billingSubject != 'XGF') || (data.name == '发票-新蜂会计' && opprove.billingSubject == 'XGF'))  && lastNodeName != '审批结束'" label="发票提醒" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-tooltip  placement="top" title="发票未与订单关联时提醒">
					该发票申请未与订单关联，如开票后需申请人提交信息补充请按 确定
				</a-tooltip>
			</a-form-item>
			<a-form-item v-if="outcome == '驳回' && keyy == 'invoiceKey' && data.name == '发票-信息补录'" label="发票提醒" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<a-tooltip  placement="top" title="信息补录驳回提醒">
					驳回后可进行发票信息编辑
				</a-tooltip>
			</a-form-item>
			<template slot="footer">
				<template v-if="outcome == '通过' && keyy == 'invoiceKey' && ((data.name == '发票-财务审批' && opprove.billingSubject != 'XGF') || (data.name == '发票-新蜂会计' && opprove.billingSubject == 'XGF')) && lastNodeName != '审批结束'">
					<a-popconfirm title="审批节点会跳过发票-信息补录,直接到审批结束?" @confirm="adoptOk('1')" okText="确定" cancelText="取消">
						<a-button key="yes" type="primary">无需补充信息并通过</a-button>
					</a-popconfirm>
				</template>
				<a-button key="back" @click="cancel">取消</a-button>
				<a-button type="primary" key="submit" @click="adoptOk()">确定</a-button>
			</template>
		</a-modal>
		<!--凭证查看-->
		<a-modal title="凭证查看" v-model="visibleVoucher" :footer="null" width="50%">
			<div style="text-align: right;margin-bottom:14px;"><a-button type="primary" icon="download" @click="downloadZip">打包全部下载</a-button></div>
			<div class="voucherImg" v-viewer="{inline: false}">
				<template v-for="(item,index) in fileList">
					<div>
						<img :src="item.iframeUrl" :key="index"/>
						<div style="text-align: center;margin: 10px;">
							<a-button type="primary" icon="download" size="small" @click="downImg(item)">下载</a-button>
						</div>
					</div>
				</template>
			</div>
		</a-modal>

		<a-modal v-model="visibleVoucher" title="图片预览" :footer="null" width="90%">
			<div style="width: 100%;height: 500px;overflow: scroll;"><img style="width: 1920px;" :src="iframeUrl" /></div>
		</a-modal>
		<add-invoice-detail ref="addInvoiceDetail" :isVisible="detailVisible" @closeModal="detailClose"/>
		<div class="example" v-show="spin">
		    <a-spin size="large" />
		</div>
	</div>
</template>

<script>
	import printJS from 'print-js'
	import {
		classify,
		folder
	} from '@/utils/fileSetting';
	import AddInvoiceDetail from '@/views/connection/invoice/addInvoice/addInvoiceDetail';
	import UploadFile from "@/views/common/UploadFile"
	import { mapGetters } from "vuex";

	const approvalColumns = [
	  {
		title: '审批编号',
	    dataIndex: 'approvalNum',
	    align: 'center',
	  },
	  {
	    title: '总报销金额(元)',
	    dataIndex: 'aggregate',
		align: 'center',
	  },
	  {
	    title: '报销明细',
		children: [
			{
				title: '金额',
				dataIndex: 'money',
				align: 'center',
			},
			{
				title: '发票类别',
				dataIndex: 'invoiceCategory',
				align: 'center',
			},
			{
				title: '发票代码',
				dataIndex: 'number',
				align: 'center',
			},
			{
				title: '用途',
				dataIndex: 'use',
				align: 'center',
			},
			{
				title: '状态',
				dataIndex: 'state',
				align: 'center',
			},
		]
	  },
	];

	export default {
		components: {
			UploadFile,
			AddInvoiceDetail
		},
		props: {
			visibleApproval: Boolean
		},
		data() {
			return {
				approvalColumns,
				spin:false,//加载中
				termArray:[],
				customStyle: 'background: #fff;border-radius: 4px;margin-bottom: 10px;border: 0;overflow: hidden',
				defaultkey: ['1', '2', '3'], // 审批记录默认展开
				business: [],
				opproveFile:[],
				approveFile:[],
				customerHistorys: [{
					title: '操作类型',
						dataIndex: 'operateTypeText',
						align: 'center'
					},
					{
						title: '变更内容',
						dataIndex: 'operateDataStr',
						align: 'left',
						scopedSlots: { customRender: 'formatOperate' }
					},
					{
						title: '操作人',
						dataIndex: 'operateUserName',
						align: 'center'
					},
					{
						title: '操作时间',
						dataIndex: 'operateTimeStr',
						align: 'center'
					},
				],

				historys: [{
						title: '审批节点',
							dataIndex: 'name',
							align: 'center'
						},
					{
						title: '处理人',
						dataIndex: 'userName',
						align: 'center'
					},
					{
						title:'签名',
						dataIndex: 'signImage',
						align:'center',
						scopedSlots: { customRender: 'formatSign' },
					},
					{
						title: '处理时间',
						dataIndex: 'endTime',
						align: 'center'
					},
					{
						title: '批注',
						dataIndex: 'message',
						align: 'center',
						width: 250
					},

				],
				historys1: [{
						title: '审批节点',
							dataIndex: 'name',
							align: 'center'
						},
					{
						title: '处理人',
						dataIndex: 'userName',
						align: 'center'
					},
					{
						title:'签名',
						dataIndex: 'signImage',
						align:'center',
						scopedSlots: { customRender: 'formatSign' },
					},
					{
						title: '状态',
						dataIndex: 'operationStatus',
						align: 'center',
						customRender: (text, row, index) => {
							if (text == '0') {
								return '提交';
							} else if(text == '1'){
								return '通过';
							} else if(text == '-1') {
								return '驳回';
							} else if(text == '2') {
								return '补录信息';
							} else {
								return '';
							}
						}
					},
					{
						title: '处理时间',
						dataIndex: 'endTime',
						align: 'center'
					},
					{
						title: '批注',
						dataIndex: 'message',
						align: 'center',
						width: 250
					},

				],
				businessData: [],
				historyData: [],
				customerHistoryData: [],
				iframeUrl: null,
				data: {},
				outcome: '',
				visibleAdopt: false,
				message: '',
				fileList: [], //凭证
				visibleVoucher: false,
				keyy: '', // 流程keyy
				detailVisible: false,
				fileArr: [],
				fileParams: {
					folder: folder.approval_invoice_file,
					classify: classify.approval_invoice_file
				},
				whetherArr: [],
				whetherElectronicTicket: null,
				invoiceNum: null,
				invoiceNumber: null,
				opprove:{}, // 审批实体
				userArr:[],
				userIds:null,// 自选审批人
				lastNode:{},
				currentVal:null,
				columnsOrder : [{  // 账号订单表头
					title: '账号订单编号',
					dataIndex: 'accountSn',
					align: 'center'
				}, {
					title: '账号名称',
					dataIndex: 'accountName',
					align: 'center'
				}, {
					title: '订单编号',
					dataIndex: 'orderSn',
					align: 'center'
				}, {
					title: '账号最终报价',
					dataIndex: 'accountFinalPrice',
					align: 'center'
				}, ],
				accountOrderList:[],
				planData: [],
				nextUserNames:'', // 下一个节点审批人
				lastNodeName:'', // 下一个节点审批人
				pvmList:[],
				taskState:{}, // 任务状态
				fileTypeArr: ['png','jpeg','jpe','jpg'],
				visibleVoucher: false,
				iframeUrl: null,
			}
		},
		computed: {
		    ...mapGetters(["permissions"]),
		    permissionList() {
		      return {
		        addSpecial: this.permissions.includes('invoice:addSpecial'),
		      };
		    }
		},
		mounted() {
			this.$get("dictionary-detail/listByDictType/whether").then(res => {
				this.whetherArr = res.data;
			});
		},
		methods: {
			// 获取图片流
			getPhotoStream(file) {
				this.$stream(`file/getFileInputStream/${file.id}`).then(res => {
					this.iframeUrl = window.URL.createObjectURL(res.data);
					this.visibleVoucher = true;
				})
			},
			termBtn(item){
				this.$post("actRePreposeBusiness/update", { id:item.id }).then(res => {
					item.state = 1
					this.$message.success('操作成功')
				});
			},
			selectPerson(value){
				this.userIds = value.join(",");
			},
			detailClose() {
				this.detailVisible = false;
			},
			invoiceDetail(){
				this.detailVisible = true;
				this.$refs.addInvoiceDetail.onlyReadOrder(this.opprove.id)
			},
			onClose() {
				this.fileArr = [];
				this.whetherElectronicTicket = null;
				this.invoiceNum = null;
				this.invoiceNumber = null;
				this.$parent.visibleApproval = false;
				this.$emit('stayDo')
			},
			hisActivity(v) {
				let that = this;
				this.keyy = v.keyy
				this.data = v;
				/* 获取流程图 */
				this.$stream('activiti/task/trace/photo', {
					execId: v.executionId
				}).then((res) => {
					this.iframeUrl = window.URL.createObjectURL(res.data);
				})

				/* 历史记录 */
				this.$get("activiti/task/hiCommentList", {
					procInstId: v.procInstId
				}).then(res => {
					this.historyData = res.data
				})

				// 审批按钮
				this.$get('activiti/task/getLineNameListNew', {
					procinstId:v.procInstId,
				}).then((res) => {
					this.pvmList = []
					if(res.data){
						if (this.keyy == 'invoiceKey' && res.data && res.data.length == 1 && res.data[0] == '提交') {
							this.pvmList = ['编辑'];
						} else {
							this.pvmList = res.data;
						}
					}

				})



				/* 业务详情 */
				this.$get('activiti/task/getBusinessDetail', {
					procinstId: v.procInstId
				}).then((res) => {
					this.opprove = {};
					if(res.data){
						this.opprove = res.data.businessObj;
						this.taskState = res.data.taskState;
					}
					if(this.keyy == 'singleAgreement'){
						this.$get("orderRefund/getByAgreementId", {
							id: this.opprove.id
						}).then(r => {
							if (r.data) {
								this.planData = r.data
							}
						});
					}
					/* 发票记录 */
					if (this.keyy == 'invoiceKey'){
						this.defaultkey = ['1']
					}
					/* 客户变更记录 */
					if (this.keyy == 'customerKey' || this.keyy == 'businessCustomerKey'){
						this.$get("/customer-change-detail/listByCustomerId", {
							customerId: this.opprove.id
					    }).then(res => {
							this.customerHistoryData = res.data
					    })
					}
					this.getFiles(this.opprove); // 附件
					this.getAccountOrderList(this.opprove);
					this.businessData = [];
					this.businessData.push(this.opprove);
					this.currentVal = this.opprove.approvalType;
					let cusColumns = []
					let myBusiness = [{
							title: '审批编号',
							dataIndex: 'approvalNum',
							align: 'center'
						},
						{
							title: '总报销金额(元)',
							dataIndex: 'aggregate',
							align: 'center'
						},
						{
							title: '凭证',
							dataIndex: 'approvalDetail',
							align: 'center',
							scopedSlots: {
								customRender: 'format11'
						},
					}]
					switch (this.opprove.approvalType){// 设置表头
						case '1':
							cusColumns = [{
								title:'报销明细',
								children:[
								{
									title:'金额',
									dataIndex: 'money',
									align:'center',
									scopedSlots: { customRender: 'format7' },
								},
								{
									title:'发票类别',
									dataIndex: 'invoiceCategory',
									align:'center',
									scopedSlots: { customRender: 'format6' },
								},
								{
									title: '发票代码',
									dataIndex: 'number',
									align: 'center',
									scopedSlots: { customRender: 'format8' },
								},
								{
									title:'用途',
									dataIndex: 'use',
									align:'center',
									scopedSlots: { customRender: 'format1' },
								},
								{
									title: '状态',
									dataIndex: 'state',
									align: 'center',
									scopedSlots: { customRender: 'format10' },
								}
							]},
						]
							break;
						case '2':
							cusColumns = [{
								title:'报销明细',
								children:[
								{
									title:'出发日期',
									dataIndex: 'startTime',
									align:'center',
									scopedSlots: { customRender: 'format3' },
								},
								{
									title:'出发地点 ',
									dataIndex: 'startPlace',
									align:'center',
									scopedSlots: { customRender: 'format4' },
								},
								{
									title:'到达日期',
									dataIndex: 'endTime',
									align:'center',
									scopedSlots: { customRender: 'format5' },
								},
								{
									title:'到达地点',
									dataIndex: 'endPlace',
									align:'center',
									scopedSlots: { customRender: 'format9' },
								},
								{
									title:'发票类别',
									dataIndex: 'invoiceCategory',
									align:'center',
									scopedSlots: { customRender: 'format6' },
								},
								{
									title: '发票代码',
									dataIndex: 'number',
									align: 'center',
									scopedSlots: { customRender: 'format8' },
								},
								{
									title:'金额',
									dataIndex: 'subtotal',
									align:'center',
									scopedSlots: { customRender: 'format7' },
								},
								{
									title:'用途',
									dataIndex: 'use',
									align:'center',
									scopedSlots: { customRender: 'format1' },
								},
								{
									title: '状态',
									dataIndex: 'state',
									align: 'center',
									scopedSlots: { customRender: 'format10' },
								}
							]},
						]
							break;
						case '3':
							cusColumns = [{
								title:'报销明细',
								children:[
								{
									title:'金额',
									dataIndex: 'money',
									align:'center',
									scopedSlots: { customRender: 'format7' },
								},
								{
									title:'发票类别',
									dataIndex: 'invoiceCategory',
									align:'center',
									scopedSlots: { customRender: 'format6' },
								},
								{
									title: '发票代码',
									dataIndex: 'number',
									align: 'center',
									scopedSlots: { customRender: 'format8' },
								},
								{
									title:'用途',
									dataIndex: 'use',
									align:'center',
									scopedSlots: { customRender: 'format1' },
								},
								{
									title: '状态',
									dataIndex: 'state',
									align: 'center',
									scopedSlots: { customRender: 'format10' },
								}
							]},
						]
							break;
						case '4':
							cusColumns = [{
								title:'报销明细',
								children:[
								{
									title:'收款单位',
									dataIndex: 'payeeName',
									align:'center',
									scopedSlots: { customRender: 'format3' },
								},
								{
									title:'银行账号 ',
									dataIndex: 'bankAccount',
									align:'center',
									scopedSlots: { customRender: 'format4' },
								},
								{
									title:'开户行',
									dataIndex: 'bankName',
									align:'center',
									scopedSlots: { customRender: 'format5' },
								},
								{
									title:'发票类别',
									dataIndex: 'invoiceCategory',
									scopedSlots: { customRender: 'format6' },
									align:'center'
								},
								{
									title: '发票代码',
									dataIndex: 'number',
									align: 'center',
									scopedSlots: { customRender: 'format8' },
								},
								{
									title:'金额',
									dataIndex: 'money',
									align:'center',
									scopedSlots: { customRender: 'format7' },
								},
								{
									title:'用途',
									dataIndex: 'use',
									align:'center',
									scopedSlots: { customRender: 'format1' },
								},
								{
									title: '状态',
									dataIndex: 'state',
									align: 'center',
									scopedSlots: { customRender: 'format10' },
								}
							]},
						]
							break;
						case '5':
							cusColumns = [{
								title:'报销明细',
								children:[
								{
									title:'借款人',
									dataIndex: 'borrowerName',
									align:'center',
									scopedSlots: { customRender: 'format3' },
								},
								{
									title:'还款报销日期 ',
									dataIndex: 'repaymentTime',
									align:'center',
									scopedSlots: { customRender: 'format4' },
								},
								{
									title:'发票类别',
									dataIndex: 'invoiceCategory',
									align:'center',
									scopedSlots: { customRender: 'format6' },
								},
								{
									title: '发票代码',
									dataIndex: 'number',
									align: 'center',
									scopedSlots: { customRender: 'format8' },
								},
								{
									title:'金额',
									dataIndex: 'money',
									align:'center',
									scopedSlots: { customRender: 'format7' },
								},
								{
									title:'用途',
									dataIndex: 'use',
									align:'center',
									scopedSlots: { customRender: 'format1' },
								},
								{
									title: '状态',
									dataIndex: 'state',
									align: 'center',
									scopedSlots: { customRender: 'format10' },
								}
							]},
						]
							break;
						default:
							break;
					}
					this.business = myBusiness.slice(0,2).concat(cusColumns).concat(myBusiness.slice(2))
					// 节点详情


				})

			},
			// 流赋值
			lookImg(v) {
				console.log(v)
				let that = this;
				this.$get('file/fileList/approval_file/' + v.id).then((r) => {
					if (r.data.length > 0) {
						that.fileList = r.data;
						for (var i = 0; i < this.fileList.length; i++) {
							that.getStream(this.fileList[i]);
						}
						that.visibleVoucher = true;
					} else {
						this.$message.warning('暂无凭证');
					}
				})
			},
			// 下载
			downImg(file) {
				this.$download(`file/downloadFile/${file.id}`, {}, file.fileFullName);
			},
			// 全部下载
			downloadZip(){
				this.$download("file/downloadFile/approval_file/"+this.opprove.id,{},this.opprove.approvalNum+"附件包.zip").then(res => {});
			},
			// 获取图片流
			getStream(file) {
				this.$stream(`file/getFileInputStream/${file.id}`).then(res => {
					file.iframeUrl = window.URL.createObjectURL(res.data);
				})
			},
			submitTo(i) {
				this.outcome = i;
				if (this.outcome == '编辑' && this.keyy == 'invoiceKey') {
					this.$router.push({
					    path: '/invoiceManagement/editInvoice',
						query: {
							id: this.opprove.id,
							isSpecial: this.permissionList.addSpecial,
							whetherSupplement : '0'
						}
					})
					this.$parent.visibleApproval = false;
					return
				}
				if (this.outcome == '补录信息' && this.keyy == 'invoiceKey') {
					this.$router.push({
					    path: '/invoiceManagement/supplementaryInvoice',
						query: {
							id: this.opprove.id,
							isSpecial: this.permissionList.addSpecial,
							whetherSupplement : '1'
						}
					})
					this.$parent.visibleApproval = false;
					return
				}
				if (this.outcome == '通过' && this.keyy == 'invoiceKey' && this.data.name == '发票-财务审批') {
					this.$get('invoice/getInvoiceById', { id: this.data.businessKey }).then(res => {
						this.invoiceNum = res.data.invoiceNum;
						this.invoiceNumber = res.data.invoiceNumber;
						this.fileArr = res.data.approvalFileList;
					})
				}

				let elString = null;
				/* 回款流程变量 */
				if(this.keyy.indexOf('remainingKey') > -1){
					elString = this.opprove.accountType;
				}
				/* 公文流程变量 */
				if(this.keyy.indexOf('officeDocKey') > -1){
					elString = "approvalType=="+ "\'"+this.opprove.approvalType+"\'";
				}
				/* 报销审批流程变量 */
				if(this.keyy.indexOf('approvalKey') > -1){
					if(this.taskState.taskName.indexOf("报销-部门经理审批") >-1 ){
						if(this.opprove.companyType == 3){
							elString = "companyType==3";
						}else{
							elString = "companyType!=3";
						}
					}
					if(this.taskState.taskName.indexOf("报销-负责人审批(天眼)") > -1 || this.taskState.taskName.indexOf("报销-财务主管审批")>-1 ){
						if(this.opprove.aggregate >= 5000){
							elString = "money >= 5000";
						}else{
							elString = "money < 5000";
						}
					}
					if(this.taskState.taskName.indexOf("报销-会计审批(天眼)")>-1 || this.taskState.taskName.indexOf("报销-会计审批")>-1 ){
						if(this.opprove.aggregate >= 1000){
							elString = "money >= 1000";
						}else{
							elString = "money < 1000";
						}
					}
				}
				/* 客户流程变量 */
				if(this.keyy.indexOf('customerKey') > -1  || this.keyy.indexOf('businessCustomerKey') > -1 ){
					if(this.opprove.discount < 0.9 || this.opprove.acctPeriod > 1 || this.opprove.whetherChangeRebate == 1){
						elString = "flag == "+ "\"2\"";
					}else{
						elString = "flag == "+ "\"1\"";
					}

				}
				/* 对账单流程变量 */
				if(this.keyy.indexOf('billKey') > -1){
					elString = this.opprove.roleType;
				}
				/* 发票是否二级审批流程变量 */
				if(this.keyy.indexOf('invoiceKey') > -1 ){
					// if (this.opprove.billingSubject == 'WH') {
					// 	elString = "flag1 == '2'";
					// } else {
					// 	elString = "flag1 == '1'";
					// }
					if (this.outcome == '通过' && this.taskState.taskName.indexOf("发票-财务审批")>-1 ) {
						if (this.opprove.billingSubject == 'XGF') {
							elString = "flag2 == '3'";
						} else if (this.opprove.invoiceDetailList && this.opprove.invoiceDetailList.length > 0 ) {
							elString = "flag2 == '1'";
						} else {
							elString = "flag2 == '2'";
						}
					}

					if ((this.taskState.taskName.indexOf("发票-财务审批")>-1 || this.taskState.taskName.indexOf("发票-文创会计审批")>-1 || this.taskState.taskName.indexOf("发票-文化会计审批")>-1 || this.taskState.taskName.indexOf("发票-电商会计审批")>-1 || this.taskState.taskName.indexOf("发票-新蜂会计审批")>-1 || this.taskState.taskName.indexOf("发票-新蜂会计")>-1)  && this.outcome == '驳回') {
						if (this.opprove.whetherSupplement== '1' ) {
							elString = "flag3 == '2'";
						} else {
							elString = "flag3 == '1'";
						}
					}

					if (this.taskState.taskName.indexOf("发票-新蜂会计")>-1 && this.outcome == '通过' ) {
						if (this.opprove.invoiceDetailList && this.opprove.invoiceDetailList.length > 0 ) {
							elString = "flag4 == '1'";
						} else {
							elString = "flag4 == '2'";
						}
					}

				}
				this.getNextNodeDetail(elString,i);
				this.visibleAdopt = true;
			},
			adoptOk(isSkip) {
				this.spin=true;
				if(this.outcome == '通过' && this.termArray.length > 0 ){
					let count = 0;
					this.termArray.forEach(function(v){
						if(v.state){
							count = count + v.state
						}
					})
					if(count != this.termArray.length){
						this.$message.error('请完成审批注意事项!')
						this.spin=false;
						return
					}
					this.spin=false;
				}
				if(this.outcome == '驳回' && !this.message){
					this.$message.error('请输入驳回理由!')
					this.spin=false;
					return;
				}
				// if(this.outcome == '通过' && this.keyy == 'invoiceKey' && this.data.name != '发票-新蜂会计审批' && this.lastNodeName == '审批结束' && (this.whetherElectronicTicket == null || this.whetherElectronicTicket == '') ){
				// 	this.$message.error('请选择是否电子票!')
				// 	this.spin=false;
				// 	return
				// }
				if(this.outcome == '通过' && this.keyy == 'invoiceKey' && this.data.name == '发票-财务审批' && (this.lastNodeName == '审批结束' || (this.lastNodeName == '发票-信息补录' && isSkip == '1') || this.opprove.billingSubject == 'XGF')  && (this.invoiceNum == null || this.invoiceNum == '') ){
					this.$message.error('请填写发票号码!')
					this.spin=false;
					return
				}
				if(this.outcome == '通过' && this.keyy == 'invoiceKey' && this.data.name == '发票-财务审批' && (this.lastNodeName == '审批结束' || (this.lastNodeName == '发票-信息补录' && isSkip == '1') || this.opprove.billingSubject == 'XGF')  && (this.invoiceNumber == null) ){
					this.$message.error('请填写发票张数!')
					this.spin=false;
					return
				}
				let lastNodeName = this.lastNodeName;
				if(this.outcome == '通过' && this.keyy == 'invoiceKey' && (this.lastNodeName == '发票-信息补录' && isSkip == '1') && (this.message == null || this.message == '') ) {
					this.message = '无需补充信息并通过';
					lastNodeName = '审批结束';
				}
				/*自选审批人*/
				if(this.lastNode.chooseUser == 1 ){
					if (!this.userIds){
						this.$message.error('请选择审批人!')
						this.spin=false;
						return
					}
					if(this.userIds.split(",").length > 3){
						this.$message.error('选择审批人不能超出3人!')
						this.spin=false;
						return
					}
				}
				var fileIds = [];
				this.fileArr.forEach(function(item) {
					fileIds.push(item.id);
				});
				let param = {
					message: this.message,
					whetherElectronicTicket: this.whetherElectronicTicket,
					invoiceNum:this.invoiceNum,
					invoiceNumber:this.invoiceNumber,
					fileIds: fileIds.join(','),
					outcome: this.outcome,
					id: this.data.id,
					procInstId: this.data.procInstId,
					executionId: this.data.executionId,
					userIds:this.userIds,
					businessKey: this.opprove.id,
					lastNodeName: lastNodeName,
					isSkip: isSkip
				}
				this.$post("activiti/task/finishTask", { ...param
				}).then(res => {
					this.spin=false;
					this.$message.success('审批成功')
					this.visibleAdopt = false;
					this.initApproval();
					this.onClose();
					if (this.keyy == 'invoiceKey') {
						this.$root.Bus.$emit('invoiceList');
						this.$root.Bus.$emit('taskList');
						this.$root.Bus.$emit('homeActivityTaskList');
					}
				});
			},
			cancel() {
				this.message = '';
				this.visibleAdopt = false;
			},
			/* 附件 */
			getFiles(v){
				let urls = "";
				if(this.keyy.indexOf('singleAgreement') > -1){
					urls = 'file/fileList/order_agreement/'
				}
				if(this.keyy.indexOf('yearAgreement') > -1){
					urls = 'file/fileList/order_agreement_year_frame/'
				}
				if(this.keyy.indexOf('supplierAgreement') > -1){
					urls = 'file/fileList/order_agreement_supplier/'
				}
				if(this.keyy.indexOf('billKey') > -1){
					urls = 'file/fileList/order_agreement_bill/'
				}
				if(this.keyy.indexOf('sideKey') > -1){
					urls = 'file/fileList/order_agreement_side/'
				}
				if(this.keyy.indexOf('knowledgeTheoryKey') > -1 || this.keyy.indexOf('knowledgeTheoryKeyOther') > -1){
					urls = 'file/fileList/knowledge_theory/'
				}
				if(this.keyy.indexOf('invoiceKey') > -1 ){
					urls = 'file/fileList/invoice_file/'
					this.$get( 'file/fileList/approval_invoice_file/' + v.id).then((r) => {
						if(r.data){
							this.approveFile = r.data;
						}
					})
				}
				if(!urls){
					return;
				}
				this.$get( urls + v.id).then((r) => {
					if(r.data){
						this.opproveFile = r.data;
					}
				})
			},
			/* 账号订单列表查询 */
			getAccountOrderList(v){
				if(this.keyy.indexOf('billKey') > -1){
					if(!v.id){return;}
					let url = 'orderAgreementBillAccount/list';
					if(v.agreementType == 2){
						url = 'orderAgreementBillYearAccount/list';
					}
					this.$get(url,{billId:v.id}).then(res => {
						this.accountOrderList = res.data
					});
				}
			},
			printPage(){
				printJS({
					printable: 'printMe',
					type: 'html',
							maxWidth: '100%',
							targetStyles: ['*']
						});
					},
			printOfficeDocPage(){
				printJS({
					printable: 'printOfficeDoc',
					type: 'html',
					maxWidth: '100%',
					targetStyles: ['*']
				});
			},
			getNextNodeDetail(elString,outcomeString){
				this.$get('activiti/task/getNodeDetailForProcinstId', {id: this.data.executionId,businessId:this.opprove.id,elString:elString,outcomeString:outcomeString}).then((r) => {
					if(r.data){
						this.initNodeDetail()
						if(r.data.bussinessList) this.termArray = r.data.bussinessList;
						if(r.data.userList) this.userArr = r.data.userList;
						if(r.data.lastNode) this.lastNode = r.data.lastNode;
						if(r.data.userNames) this.nextUserNames = r.data.userNames;
						if(r.data.lastNodeName) this.lastNodeName = r.data.lastNodeName;
					}
				})
			},
			initNodeDetail(){
				this.termArray = [];
				this.userArr = [];
				this.lastNode = {};
				this.nextUserNames = "";
				this.lastNodeName = "";
			},
			initApproval(){
				this.message = '';
				this.fileArr = [];
				this.whetherElectronicTicket = null;
				this.invoiceNum = null;
				this.invoiceNumber = null;
				this.outcome = null;
				this.userIds = null;
			}
		}
	}
</script>

<style lang="less" scoped>
	.approvalBtn {
		text-align: right;
		padding-right: 16px;
		overflow: hidden;
		button {
			margin-left: 10px;
		}
	}

	.voucherImg {
		display: flex;
		flex-wrap: wrap;

		img {
			width: 200px;
			height: 200px;
			margin-right: 10px;
			// margin-bottom: 1%;
			border: 1px solid #C0C0C0;
			background: #F5F5F5;
			cursor: pointer;
		}

	}
	.term{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 0 10px 10px;
	}
	.example{
		position: fixed;
		top:0;
		width:100vw;
		height:100vh;
		display: flex;
		padding-right:15vw;
		justify-content: center;
		align-items:center;
		z-index: 9999999;
	}
</style>



// WEBPACK FOOTER //
// src/views/task/todoTask/approvalUnit.vue